import Component from '../core/Component'
import { substitute } from '../utils/String'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class SearchNoResult extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            template: null,
            content: null
        }

        this.timer = null
    }

    prepare() {
        this.template = this.ref.template.textContent
    }

    render(query) {
        this.ref.content.innerHTML = substitute(this.template, {
            query
        })
    }
}